module.exports = __webpack_public_path__ + "static/media/sort-circle-down.0e28a1e0.svg";